export default __webpack_public_path__ + "static/media/Curvetempty.8970c3a8.svg";